module.exports = __webpack_public_path__ + "static/img/service_qr_code.489df9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/service_qr_code.png
// module id = 3sam
// module chunks = 21